.Heading {
  font-size: 1.375rem;
  font-weight: 500;
  color: var(--primary);

  & > span:last-child {
    display: block;
    margin-top: 4px;
    font-size: 0.875rem;
    font-weight: normal;
  }
}
